<div class="sourcing-outcome-container">
    <p class="heading-h6-medium">Sourcing outcome</p>
    <p class="heading-h8-medium">Item no. will be reflected once RO has finished evaluating.</p>
    <div class="vendor-basic-info">
        <div class="vendor-invited-info">
            <p>Vendors invited: {{ vendorsInvited }}</p>
        </div>
        <div class="vendor-quoted-info">
            <p>Vendors quoted: {{ vendorsQuoted }}</p>
        </div>
    </div>
    <div class="sourcing-outcome-table-container">
        <table mat-table [dataSource]="sourcingOutcomeDS" class="mat-elevation-z8 sourcing-outcome-table">
            <ng-container *ngFor="let column of columns; let i = index" [matColumnDef]="column.columnDef">
                <!-- Vendor Name Column -->
                <div class="vendor-name" *ngIf="column.columnDef == 'VendorName'">
                    <th mat-header-cell *matHeaderCellDef>
                        {{ column.header }}
                    </th>
                    <td mat-cell *matCellDef="let row" [tp]="row.Name" tpClassName="custom-tooltip" tpMaxWidth="300px"
                        [tpInteractive]="true" [tpIsEnabled]="row.Name.length > 64" tpPlacement="bottom">
                        {{ row.Name| truncateMiddle:56 }}
                    </td>
                </div>
                <!-- Quote Received Column -->
                <div class="quote-received" *ngIf="column.columnDef == 'QuoteReceived'">
                    <th mat-header-cell *matHeaderCellDef>
                        {{ column.header }}
                    </th>
                    <td mat-cell *matCellDef="let row">
                        {{ row.Status ? "Yes" : "No"}}
                    </td>
                </div>

                <!-- Quote Expiry Column -->
                <div class="quote-expiry" *ngIf="column.columnDef == 'QuoteExpiringOn'">
                    <th mat-header-cell *matHeaderCellDef>
                        {{ column.header }}
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <ng-container *ngIf="isReadOnlyRFQSummary; else editableQuoteExpiry">
                            <span *ngIf="row.QuoteExpiring" [ngClass]="{'expired-date':  row.HavingExpiredQuote}">
                                {{ row.QuoteExpiring | date: 'dd/MM/yyyy' }}
                                <span *ngIf="row.HavingExpiredQuote"> (Expired)</span>
                            </span>
                            <span *ngIf="!row.QuoteExpiring">-</span>
                        </ng-container>
                        <ng-template #editableQuoteExpiry>
                            <mat-form-field class="date-picker" *ngIf="row.Status; else noQuote">
                                <mat-label>DD/MM/YYYY</mat-label>
                                <input matInput [matDatepicker]="pickerPlannedDate" id="plannedDDPicker" [min]="minDate"
                                    [(ngModel)]="row.QuoteExpiring">
                                <mat-datepicker-toggle matIconSuffix [for]="pickerPlannedDate"></mat-datepicker-toggle>
                                <mat-datepicker #pickerPlannedDate></mat-datepicker>
                            </mat-form-field>
                            <ng-template #noQuote>
                                <span>-</span>
                            </ng-template>
                        </ng-template>
                    </td>
                </div>

                <!-- Reason for no quotation Column -->
                <div class="reason-for-no-quotation" *ngIf="column.columnDef == 'ReasonForNoQuotation'">
                    <th mat-header-cell *matHeaderCellDef>
                        {{ column.header }}
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <ng-container *ngIf="isReadOnlyRFQSummary; else editableReason">
                            <span *ngIf="reasonForNoQuotation && reasonForNoQuotation.length > 0">
                                {{getReason( row.ReasonForNoQuotationId )}}</span>
                        </ng-container>
                        <ng-template #editableReason>
                            <ng-container *ngIf="!row.Status; else noQuote">
                                <ng-select class="dropdown noReasonSelect" [items]="reasonForNoQuotation"
                                    appearance="outline" bindLabel="value" bindValue="id" [appendTo]="'body'"
                                    style="padding-bottom: 0;" placeholder="Please select an option"
                                    [(ngModel)]="row.ReasonForNoQuotationId"
                                    [matTooltip]="getReason( row.ReasonForNoQuotationId ) ?? ''"
                                    matTooltipClass="mat-custom-tooltip"
                                    >
                                </ng-select>
                            </ng-container>
                            <ng-template #noQuote>
                                <span>-</span>
                            </ng-template>
                        </ng-template>
                    </td>
                </div>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
    <!-- </form> -->
    <mat-paginator *ngIf="sourcingOutcomeDS.data.length > 0" #attachmentPg [length]="sourcingOutcomeDS.data.length"
        [pageSize]="20" showFirstLastButtons showFirstLastButtons></mat-paginator>
</div>